import { IDelays } from './types';

export const delays: IDelays = {
  constructor: 500,
  onChange: 100,
  resendCode: 5000,
  fedKeepLoading: 10000,
};
